import ACTION_ITEMS from '../actionItems';

export function setCurrentPageTab(currentPage, activeTab) {
  return {
    type: ACTION_ITEMS.NAVBAR.SET_CURRENT_PAGE_TAB,
    payload: { currentPage, activeTab }
  };
};



// WEBPACK FOOTER //
// ./src/components/navbar/actions/setCurrentPageTab.js